import { reducer as oidcReducer } from "redux-oidc";
import { CommonAppState, Navigation, versionSlice, errorSlice, notificationSlice } from '@konicaminolta/common-react';
import * as Dashboard from './Dashboard';
import * as DatasetRefreshHistory from './DatasetRefreshHistory';
import * as Group from './Group';
import * as Report from './Report';

import TimeAgo from 'javascript-time-ago';
import en from "javascript-time-ago/locale/en.json";


TimeAgo.addDefaultLocale(en);

// The top-level state object
export interface AppState extends CommonAppState {
    dashboard: Dashboard.DashboardState;
    report: Report.ReportState;
    group: Group.GroupState;
    datasetRefreshHistory: DatasetRefreshHistory.DatasetRefreshHistoryState;
}

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
export const reducers = {
    oidc: oidcReducer,
    version: versionSlice.reducer,
    navigation: Navigation.reducer,
    notification: notificationSlice.reducer,
    errors: errorSlice.reducer,
    dashboard: Dashboard.reducer,
    report: Report.reducer,
    group: Group.reducer,
};

// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
export interface AppThunkAction<TAction> {
    (dispatch: (action: TAction) => void, getState: () => AppState): void;
}
